var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterApplied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1788 3.71094H5.49329C5.07275 3.71094 4.84007 4.19851 5.10459 4.52544L11.138 11.9823C11.21 12.0713 11.2493 12.1823 11.2493 12.2968V17.698C11.2493 17.8559 11.3239 18.0046 11.4506 18.0989L13.5843 19.6886C13.9141 19.9343 14.383 19.6989 14.383 19.2876V12.3041C14.383 12.1852 14.4254 12.0702 14.5026 11.9797L17.3022 8.69666",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9727 7.33203C19.3534 7.33203 20.4727 6.21274 20.4727 4.83203C20.4727 3.45132 19.3534 2.33203 17.9727 2.33203C16.5919 2.33203 15.4727 3.45132 15.4727 4.83203C15.4727 6.21274 16.5919 7.33203 17.9727 7.33203Z",
    fill: "#1859B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterApplied);
export default __webpack_public_path__ + "static/media/filter-applied.610a946b220b91feee9076974af4f129.svg";
export { ForwardRef as ReactComponent };